<template>
  <div class="services-box">
    <menuBox :step="3"></menuBox>
    <div class="content-top">
      <div class="title">Pilih kami untuk merekam kehidupan dengan film dan membuat hidup lebih baik.</div>
      <div class="text">Rumah/Hubungi kami</div>
    </div>
    <div class="joinUs-box">
      <img src="../assets/services1.png" />
      <div class="info">
        <div class="bt">Hubungi kami</div>
        <div class="line"></div>
        <div class="title">Pembuatan film dan televisi, kami memahami Anda dengan lebih baik. Bersama kami, setiap
          pengambilan gambar dibuat khusus untuk Anda. Baik itu film, video, atau acara TV, kami menggunakan produksi
          profesional dan kreativitas tanpa batas untuk menjadikan cerita Anda puncak seni visual.</div>
        <div class="inputBox">
          <input type="text" placeholder="Nama">
          <input type="text" placeholder="Surat">
          <input type="text" placeholder="Telepon">
          <textarea class="message" type="text" placeholder="Konten artikel" />
          <div class="btn" @click="sendInfo">Mengirim pesan</div>
        </div>
      </div>
    </div>
    <footerBox></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {};
  },
  mounted() { },
  methods: {
    sendInfo() {
      alert('ส่งเรียบร้อยแล้ว')
    }
  },
};
</script>
<style lang="less" scoped>
.content-top {
  padding: 200px 360px 0;
  background-image: url(../assets/services.png);
  width: 100%;
  height: 640px;
  background-size: 100% 100%;
  overflow: hidden;
  box-sizing: border-box;
  text-align: center;

  .title {
    margin-bottom: 20px;
    font-weight: bold;
    font-size: 56px;
    color: #FFFFFF;
    line-height: 79px;
  }

  .text {
    font-weight: bold;
    font-size: 24px;
    color: #E5D806;
    line-height: 33px;
  }
}

.joinUs-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #1E1D21;
  padding: 100px 312px;
  box-sizing: border-box;

  img {
    margin-right: 60px;
    width: 600px;
    height: 690px;
  }

  .info {
    padding: 50px;
    width: 640px;
    height: 690px;
    background: #393939;
    box-sizing: border-box;

    .bt {
      margin-bottom: 10px;
      font-weight: 700;
      font-size: 24px;
      color: #FFFFFF;
      line-height: 33px;
    }

    .line {
      margin-bottom: 16px;
      width: 40px;
      height: 3px;
      background: #E5D806;
    }

    .title {
      margin-bottom: 20px;
      font-weight: 600;
      font-size: 16px;
      color: #FFFFFF;
      line-height: 22px;
    }

    .inputBox {
      input {
        margin-bottom: 10px;
        padding: 20px;
        width: 541px;
        height: 48px;
        background: #5C5C5C;
        box-sizing: border-box;
      }

      textarea {
        padding: 20px;
        width: 541px;
        height: 140px;
        background: #5C5C5C;
        box-sizing: border-box;
      }

      .btn {
        display: table;
        margin-top: 20px;
        padding: 20px 50px;
        background: #E5D806;
        font-weight: 600;
        font-size: 20px;
        color: #1E1D21;
        line-height: 30px;
        cursor: pointer;
      }
    }
  }
}
</style>
